export const LAYER_RECIPES = [
  {
    key: 'power_readiness',
    label: 'Power readiness',
    description: 'Transmission, substations, utility territory, hosting capacity, and queue context.',
    layerKeys: [
      'transmission_lines_hifld',
      'electric_substations_hifld',
      'electric_retail_service_territories_hifld',
      'utility_hosting_capacity',
      'interconnection_queue_county_summaries',
      'interconnection_queue_projects'
    ],
    parcelSourceMode: 'none'
  },
  {
    key: 'gas_bridge',
    label: 'Gas bridge',
    description: 'Gas transmission, compressor stations, processing, storage, and LNG context.',
    layerKeys: [
      'natural_gas_pipelines_eia',
      'gas_compressor_stations_hifld',
      'gas_processing_plants_hifld',
      'gas_storage_hifld',
      'lng_terminals_eia'
    ],
    parcelSourceMode: 'none'
  },
  {
    key: 'owner_outreach',
    label: 'Owner outreach',
    description: 'Parcel polygons and serving-utility context for acquisition outreach.',
    layerKeys: [
      'electric_retail_service_territories_hifld',
      'transmission_lines_hifld',
      'electric_substations_hifld'
    ],
    parcelSourceMode: 'public'
  },
  {
    key: 'environmental_risk',
    label: 'Environmental risk',
    description: 'Flood, wetlands, habitat, nonattainment, contamination, and natural hazards.',
    layerKeys: [
      'fema_flood_hazard_zones',
      'fema_national_risk_index_counties',
      'fema_national_risk_index_tracts',
      'nwi_wetlands',
      'usfws_critical_habitat',
      'padus_protected_areas',
      'epa_nonattainment_areas',
      'epa_echo_facilities'
    ],
    parcelSourceMode: 'none'
  },
  {
    key: 'market_context',
    label: 'Market context',
    description: 'Data centers, transportation, workforce/demographics, and grid territories.',
    layerKeys: [
      'data_center_sites',
      'operational_data_centers',
      'ntad_national_network_highways',
      'ntad_national_highway_freight_network',
      'ntad_rail_lines',
      'ntad_intermodal_rail_facilities',
      'ntad_commercial_airports',
      'census_tracts_acs_2024',
      'control_areas_hifld',
      'egrid_subregions_epa'
    ],
    parcelSourceMode: 'none'
  },
  {
    key: 'buildability_constraints',
    label: 'Buildability',
    description: 'Parcel ownership, flood, wetlands, protected lands, zoning gaps, and planned slope screening.',
    layerKeys: [
      'fema_flood_hazard_zones',
      'nwi_wetlands',
      'padus_protected_areas',
      'usfws_critical_habitat',
      'local_zoning_future_land_use',
      'usgs_3dep_slope_buildability'
    ],
    parcelSourceMode: 'public'
  },
  {
    key: 'water_cooling',
    label: 'Water / cooling',
    description: 'Surface water, reservoirs, public water systems, and regulated water facilities.',
    layerKeys: [
      'nhd_flowlines',
      'nhd_waterbodies',
      'epa_public_water_system_areas',
      'usace_national_inventory_dams',
      'epa_echo_facilities'
    ],
    parcelSourceMode: 'none'
  },
  {
    key: 'freight_access',
    label: 'Freight access',
    description: 'Truck freight routes, rail, intermodal terminals, ports, airports, and FAF freight nodes.',
    layerKeys: [
      'ntad_national_highway_freight_network',
      'ntad_national_network_highways',
      'ntad_rail_lines',
      'ntad_intermodal_rail_facilities',
      'ntad_faf_network_nodes',
      'usace_port_statistical_areas',
      'ntad_commercial_airports'
    ],
    parcelSourceMode: 'none'
  }
]

export const recipeByKey = (key) => LAYER_RECIPES.find((recipe) => recipe.key === key)

export const availableRecipeLayerKeys = (recipe, layers = []) => {
  const keys = new Set(layers.filter((layer) => layer.enabled !== false && layer.sourceType !== 'paid_provider').map((layer) => layer.key))

  return (recipe?.layerKeys || []).filter((key) => keys.has(key))
}

export const filterLayerCategories = (categories = [], query = '') => {
  const needle = String(query || '').trim().toLowerCase()
  if (!needle) return categories

  return categories
    .map((category) => ({
      ...category,
      layers: category.layers.filter((layer) => layerMatchesQuery(layer, category, needle))
    }))
    .filter((category) => category.layers.length > 0)
}

export const layerMatchesQuery = (layer, category, needle) => [
  layer.key,
  layer.name,
  layer.provider,
  layer.description,
  category?.label,
  category?.key,
  layer.metadata?.phase,
  layer.metadata?.status,
  layer.metadata?.coverage,
  layer.metadata?.caveat,
  layer.metadata?.pattern,
  ...(Array.isArray(layer.metadata?.unlocks) ? layer.metadata.unlocks : [])
]
  .filter(Boolean)
  .some((value) => String(value).toLowerCase().includes(needle))
